<template>
    <div>
        <!-- v-overlay could be used here, but is causing errors: https://github.com/vuetifyjs/vuetify/issues/17486 -->
        <div v-if="!loaded" class="overlay">
            <div class="d-flex align-center justify-center">
                <v-progress-circular v-if="showLoading" indeterminate color="primary" size="64"></v-progress-circular>
            </div>
        </div>
        <template v-else>
            <PreviewHeader v-if="isPreview && userType" :viewer="userType" :bookId="previewBookId" />
            <template v-else>
                <PupilHeader v-if="userType === 'pupil'" />
                <TeacherHeader v-if="userType === 'teacher'" />
                <AdminHeader v-if="userType === 'admin'" />
                <StaffHeader v-if="userType === 'staff'" />
            </template>
            <v-main id="main" :style="isPreview ? { paddingTop: '56px' } : { paddingTop: '74px' }">
                <div
                    v-if="!route.path.includes('read-book') && !isPreview"
                    id="content"
                    :class="{ wrap: userType !== 'staff', 'staff-wrap': userType === 'staff' }"
                >
                    <RouterView />
                </div>
                <div v-else class="wrap">
                    <RouterView />
                </div>
            </v-main>
        </template>
    </div>
</template>

<script setup lang="ts">
import PreviewHeader from '~/components/PreviewHeader.vue';

const loaded = ref(false);
const showLoading = ref(false);
setTimeout(() => (showLoading.value = true), 500);

const route = useRoute();
const head = useHead();
const auth = useAuth();
const { userType } = storeToRefs(auth);

const previewBookId = computed(() => {
    const staffMatch = route.path.match(/\/staff\/book\/(\d+)\/view$/);
    if (staffMatch) return parseInt(staffMatch[1]);
    const teacherMatch = route.path.match(/\/teacher\/book\/(\d+)\/view$/);
    if (teacherMatch) return parseInt(teacherMatch[1]);
    return 0;
});
const isPreview = computed(() => {
    return previewBookId.value !== 0;
});

const link = [];
const basePath = process.env.VITE_BASE_PATH || '/';
if (userType.value === 'teacher') {
    link.push({ href: `${basePath}common/css/backend.css`, rel: 'stylesheet', type: 'text/css', media: 'all' });
    link.push({ href: `${basePath}css/teacher/style.css`, rel: 'stylesheet', type: 'text/css', media: 'all' });
} else if (userType.value === 'admin') {
    link.push({ href: `${basePath}common/css/backend.css`, rel: 'stylesheet', type: 'text/css', media: 'all' });
} else if (userType.value === 'staff') {
    link.push({ href: `${basePath}css/staff/style.css`, rel: 'stylesheet', type: 'text/css', media: 'all' });
    link.push({ href: `${basePath}css/staff/backend.css`, rel: 'stylesheet', type: 'text/css', media: 'all' });
} else if (userType.value === 'pupil') {
    link.push({ href: '/css/pupil/style.css', rel: 'stylesheet', type: 'text/css', media: 'all' });
}
head.patch({ link });
loaded.value = true;
</script>
<style lang="scss" scoped>
:deep(.v-overlay__scrim) {
    background-color: rgba(var(--v-theme-background));
    opacity: 1;
}

.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--v-theme-background));
    opacity: 1;
    z-index: 2000;

    div {
        height: 100vh;
    }
}

#main {
    width: 100%;
}
</style>
